import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between p-3" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold py-3" }, "Current subscription", -1)
const _hoisted_4 = { class: "pl-1 pt-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-20 w-20 text-green-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-20 w-20 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "pl-3 flex flex-col space-y-2" }
const _hoisted_13 = { class: "text-lg font-semibold" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Plan: ")
const _hoisted_15 = { class: "font-normal pl-1" }
const _hoisted_16 = { class: "text-lg font-bold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Status: ")
const _hoisted_18 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-20 w-20 text-primary",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl pl-3 text-primary" }, "No invoices yet.", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Tooltip, { message: "you could view your current subscription." })
        ])
      ])
    ]),
    (_ctx.data !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.data?.subscription_status === 'active')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
            : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.data?.nickname), 1)
            ]),
            _createElementVNode("span", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", {
                class: _normalizeClass(["font-normal capitalize pl-1", 
            _ctx.data?.subscription_status === 'active'
              ? 'text-green-500'
              : 'text-red-500'
          ])
              }, _toDisplayString(_ctx.data?.subscription_status), 3)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
  ], 64))
}